import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { REQUEST_TYPES } from '@ordersnproducts/utils/request-types';
import * as moment from 'moment';
import { OrderBuilderFeatureState } from '@ordersnproducts/modules/order-builder/reducers';
import { RmsContractProductsRequest } from '@cemex-core/cmx-api';
import { environment } from 'environments/environment';
import { formatDateRms } from '@ordersnproducts/utils/format-date-rms';

/**
 * @param {OrderBuilderFeatureState} state
 * @param {REQUEST_TYPES} requestType
 * @return {RmsContractProductsRequest}
 */
export function createProductsRequestPayload(
  state: OrderBuilderFeatureState,
  requestType: REQUEST_TYPES = REQUEST_TYPES.ContractRequest,
): RmsContractProductsRequest {
  return {
    country: state.locationPage.jobsite.address.countryCode,
    subgroup: _safe(() => state.locationPage.calendars.calendars[0].subGroup.subGroupCode),
    comm_product: [],
    request_type: requestType,
    deliveryDate: moment().format(formatDateRms),
    application_code: environment.applicationCode[state.locationPage.jobsite.address.countryCode],
    top_product: {
      jobsite: state.locationPage.jobsite.selected.shipmentLocationCode.replace(/\b0+/g, ''),
    },
  } as RmsContractProductsRequest;
}
